import { AnswerRepository } from "../../../../data/repository/answer/AnswerRepository";
import { Message } from "../../../model/Auth";
import { Answer } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteAnswerByQuestionIdUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteAnswerByQuestionIdUseCaseImpl
  implements DeleteAnswerByQuestionIdUseCase
{
  private answerRepository: AnswerRepository;

  constructor(answerRepository: AnswerRepository) {
    this.answerRepository = answerRepository;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.answerRepository.deleteAnswerByQuestionId(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
